import React, { useState } from 'react';
import ErrorMessage from '../common/errormessage'; // Ensure this path is correct
import GeneralButton from '../common/button_general'; // Ensure this path is correct

function ImageUploadForm({ setFormData }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [error, setError] = useState('');

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (loadEvent) => {
        const base64String = loadEvent.target.result;
        setImageUrl(base64String); // Update the image preview
        setFormData(prevFormData => ({
          ...prevFormData,
          image: base64String  // Store the base64 image in the form state
        }));
      };
      reader.readAsDataURL(file);
      setSelectedFile(file);
    }
  };

  const handleUploadClick = () => {
    if (!selectedFile) {
      setError('Please select a file to upload.');
      return;
    }
    setError(''); // Clear previous errors
    // Normally upload logic would go here, but in this scenario, we're handling it all within the form submission.
  };

  return (
    <div className="p-4">
      {error && <ErrorMessage message={error} />}
      <div>
        <label htmlFor="image-upload" className="block text-sm font-medium text-gray-700">
          Item Image
        </label>
        {imageUrl && <img src={imageUrl} alt="Preview" style={{ width: '200px', height: '200px' }} />}
        <input
          id="image-upload"
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          style={{ display: 'block', margin: '10px 0' }}
        />
      </div>
      <GeneralButton onClick={handleUploadClick} buttonType="primary">
        Prepare Image
      </GeneralButton>
    </div>
  );
}

export default ImageUploadForm;
